<template>
  <div>
    <div class="heading flex items-center mb-4 mt-3">
      <ListIcon class="mr-3" />
      <div>
        <h3 class="text-lg text-left text-primary leading-snug font-semibold">
          {{ $t('order.step1') }}
        </h3>
        <h4 class="text-base text-black-display leading-snug">
          {{ $t('order.step1Description') }}
        </h4>
      </div>
    </div>
    <div class="categories">
      <ul
        v-if="loaded"
        class="flex flex-wrap"
      >
        <li
          v-for="(category, i) in categories"
          :key="`category-${i}`"
          class="w-1/2 lg:w-1/4 flex"
        >
          <transition
            name="zoom-out-fade"
            appear
          >
            <label
              class="config-btn text-gray-700 mx-1 w-full cursor-pointer mx-2 my-2 md:h-48"
              :class="{'active': chosenCategory === category.id}"
            >
              <input
                v-model="chosenCategory"
                class="hidden"
                type="radio"
                :value="category.id"
              >
              <div class="mb-3 h-24">
                <img
                  class="h-24"
                  :src="category.photo_url"
                  :alt="name(category)"
                >
              </div>
              <span class="text-xs sm:text-base md:text-lg">{{ name(category) ? stringLimit(name(category), 36) : '-' }}</span>
            </label>
          </transition>
        </li>
        <li class="w-full sm:w-1/2 lg:w-1/4">
          <transition
            name="zoom-out-fade"
            appear
          >
            <a
              tag="button"
              class="config-btn cursor-pointer h-48 mx-2 my-2"
              @click.prevent="initNewCustomOrder"
            >
              <EditIcon />
              <span class="block mt-4">
                {{ $t('start.customOrder') }}
              </span>
            </a>
          </transition>
        </li>
      </ul>
    </div>
    <div
      class="flex justify-center pb-0 animate duration-700"
      :class="{'pb-24': activeStep === 1}"
    >
      <div
        v-scroll-to="{ element: '#step-2', offset: -96, duration: 1000 }"
        class="absolute bottom-0 mb-12"
      >
        <transition name="squeeze">
          <button
            v-if="activeStep === 1"
            class="btn h-14 px-9 my-3 flex items-center"
            type="button"
            @click="initStep(2)"
          >
            {{ $t('order.addCategory') }}
          </button>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { stringLimit } from '@/utils/stringLimit';
import EditIcon from '@/assets/icons/edit.svg';
import ListIcon from '@/assets/icons/list.svg';
import name from '@/mixins/name';
import { CUSTOM_SUMMARY } from '@/router/routes.names';

export default {
  name: 'Step1',
  components: {
    EditIcon,
    ListIcon,
  },
  mixins: [name],
  props: {
    activeStep: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      chosenCategory: null,
      loaded: false,
    };
  },
  computed: {
    ...mapState('order', ['category_id', 'categories']),
  },
  watch: {
    currentLang(newLang) {
      this.changeLang({ lang: newLang });
    },
    chosenCategory(newValue, oldValue) {
      this.changeCategoryId(newValue);
      this.updateOrder([]);
      if (oldValue) {
        this.initStep(1);
        this.$router.replace({
          params: {
            categoryId: newValue,
            subcategoryId: null,
          },
        }, () => {});
      }
    },
  },
  async created() {
    const { categoryId, subcategoryId } = this.$route.params;
    if (this.categories.length > 0) this.loaded = true;
    await this.getData();
    this.loaded = true;
    if (typeof categoryId !== 'undefined') {
      this.chosenCategory = +categoryId;
      if (typeof subcategoryId !== 'undefined') {
        this.initStep(2);
      }

      return;
    }
    const firstAvailableCategory = this.categories[0].id;
    this.chosenCategory = firstAvailableCategory;
    this.$router.replace({
      params: {
        categoryId: firstAvailableCategory,
      },
    }, () => {});
  },
  methods: {
    ...mapActions('order', ['changeCategoryId', 'resetOrder', 'getData']),
    ...mapMutations('order', ['updateOrder']),
    stringLimit,
    initStep(step) {
      this.$emit('changeStep', step);
      if (this.category_id === null) {
        this.changeCategoryId(this.chosenCategory);
      }
    },
    async initNewCustomOrder() {
      await this.resetOrder();
      this.$router.push({ name: CUSTOM_SUMMARY });
    },
  },
};
</script>
<style lang="scss" scoped>
  .categories {
    min-height: 400px;
  }
</style>
